// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__eEuh6","line":"default_line__M46m2"};